var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 53,
    viewBox: "0 0 182 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    width: 168.737,
    height: 1.96014,
    fill: "#181818"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    y: 49.6567,
    width: 168.737,
    height: 2.61351,
    fill: "#181818"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 1.96021,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 175.368,
    y: 1.96021,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 3.92041,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 175.368,
    y: 47.6965,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 45.7366,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 47.6965,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 45.7366,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 3.92041,
    width: 2.21053,
    height: 1.96014,
    fill: "#181818"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "#181818"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 179.789,
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "#181818"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 6.63147,
    y: 1.96021,
    width: 99.4737,
    height: 47.6966,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 4.42102,
    y: 3.92041,
    width: 2.21053,
    height: 43.7764,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 2.21045,
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 75.8948,
    y: 1.96021,
    width: 99.4737,
    height: 47.6966,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 175.368,
    y: 3.92041,
    width: 2.21053,
    height: 43.7764,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 177.579,
    y: 5.88037,
    width: 2.21053,
    height: 39.8561,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 7.36841,
    y: 3.92041,
    width: 165.789,
    height: 1.30676,
    fill: "#835351"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 7.36841,
    y: 45.7363,
    width: 165.789,
    height: 1.30676,
    fill: "#835351"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 5.15796,
    y: 5.22705,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 5.15796,
    y: 43.7764,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 173.158,
    y: 5.22705,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 173.158,
    y: 43.7764,
    width: 2.21053,
    height: 1.96014,
    fill: "#835351"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3.6842,
    y: 7.18726,
    width: 1.47368,
    height: 36.5892,
    fill: "#835351"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 175.368,
    y: 7.18726,
    width: 1.47368,
    height: 36.5892,
    fill: "#835351"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3359 17.2656V31.4062H57.5859V17.2656H59.3359ZM48.0391 23.2812C48.0312 20.2344 49.5859 18.2969 51.7266 18.2969C53.8438 18.2969 55.4062 20.2344 55.4141 23.2812C55.4062 26.3516 53.8438 28.2812 51.7266 28.2812C49.5859 28.2812 48.0312 26.3516 48.0391 23.2812ZM49.7109 23.2812C49.7109 25.4531 50.5312 26.7109 51.7266 26.7188C52.9141 26.7109 53.7266 25.4531 53.7266 23.2812C53.7266 21.125 52.9141 19.8594 51.7266 19.8594C50.5312 19.8594 49.7109 21.125 49.7109 23.2812ZM74.2891 24.0625V25.4531H61.4141V24.0625H64.4141V22.2734C63.3438 21.8203 62.7422 21.1094 62.7422 20.1875C62.7422 18.4922 64.7188 17.5 67.8359 17.5C70.9453 17.5 72.9219 18.4922 72.9297 20.1875C72.9219 21.1172 72.3125 21.8281 71.2422 22.2734V24.0625H74.2891ZM62.9141 28.8281C62.9141 27.2031 64.75 26.2969 67.8359 26.3125C70.875 26.2969 72.7188 27.2031 72.7266 28.8281C72.7188 30.4688 70.875 31.3594 67.8359 31.3594C64.75 31.3594 62.9141 30.4688 62.9141 28.8281ZM64.5547 20.1875C64.5391 21.0469 65.75 21.5078 67.8359 21.5C69.9141 21.5078 71.1328 21.0469 71.1328 20.1875C71.1328 19.3203 69.9141 18.8359 67.8359 18.8438C65.75 18.8359 64.5391 19.3203 64.5547 20.1875ZM64.6797 28.8281C64.6719 29.625 65.7812 30.0547 67.8359 30.0469C69.8594 30.0547 70.9766 29.625 70.9922 28.8281C70.9766 28.0391 69.8594 27.6328 67.8359 27.625C65.7812 27.6328 64.6719 28.0391 64.6797 28.8281ZM66.1641 24.0625H69.5078V22.7188C69 22.7891 68.4375 22.8281 67.8359 22.8281C67.2344 22.8281 66.6719 22.7891 66.1641 22.7188V24.0625ZM81.7891 25.9844C84.7188 25.9844 86.5156 26.9766 86.5234 28.6719C86.5156 30.3906 84.7188 31.3828 81.7891 31.3906C78.8359 31.3828 77.0078 30.3906 77.0078 28.6719C77.0078 26.9766 78.8359 25.9844 81.7891 25.9844ZM75.7266 24.75V18.1562H77.4453V20.0625H80.7422V18.1562H82.4609V24.75H75.7266ZM77.4453 23.375H80.7422V21.4219H77.4453V23.375ZM78.7422 28.6719C78.7422 29.5469 79.8516 30.0234 81.7891 30.0156C83.7188 30.0234 84.8047 29.5469 84.8047 28.6719C84.8047 27.7969 83.7188 27.3516 81.7891 27.3438C79.8516 27.3516 78.7422 27.7969 78.7422 28.6719ZM84.6484 25.6406V17.2656H86.3828V20.6406H88.3516V22.0938H86.3828V25.6406H84.6484ZM91.4453 18V19.9219H94.6016V18H96.3203V20.5781H99.1641V17.2656H100.898V24.9844H99.1641V22.0156H96.3203V24.5469H89.7109V18H91.4453ZM91.4453 23.1406H94.6016V21.2656H91.4453V23.1406ZM91.5859 31.1875V25.6094H93.3203V27.0469H99.1641V25.6094H100.898V31.1875H91.5859ZM93.3203 29.7812H99.1641V28.3906H93.3203V29.7812ZM119.602 28.2656V29.6875H106.695V28.2656H112.258V25.5156H108.117V18.2031H109.852V20.5156H116.398V18.2031H118.133V25.5156H113.977V28.2656H119.602ZM109.852 24.1094H116.398V21.9062H109.852V24.1094ZM132.32 17.2656V31.3906H130.57V17.2656H132.32ZM120.617 27.5C124.32 25.7422 126.023 23.3516 126.336 20.1406H121.336V18.7656H128.102C128.102 22.9688 126.469 26.5391 121.523 28.8906L120.617 27.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationButton);
export default __webpack_public_path__ + "static/media/InformationButton.beca09c452fd486c29c10f6e67083ddb.svg";
export { ForwardRef as ReactComponent };